import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

export const fetchRefersList = createAsyncThunk(
  'customer_refers/fetchRefersList',
  async (page , { rejectWithValue }) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/customer/get-refers-list?page=${page}`
      );
      return response.data;  // Return videos data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const inviteSlice = createSlice({
  name: 'customer_refers',
  initialState: {
    refers_list: [],
    currentPage: 1,
    totalPages: 1,
    loading: false,
    errorMessage: '',
  },
  reducers: {
    clearMessage: (state, action) => {
      state.errorMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder      
      // Handle get started videos
      .addCase(fetchRefersList.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(fetchRefersList.fulfilled, (state, action) => {
        state.refers_list = action.payload.data.data;
        state.currentPage = action.payload.data.current_page;
        state.totalPages = action.payload.data.last_page;
        state.loading = false;
      })
      .addCase(fetchRefersList.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload ? action.payload.message : action.error.message;
      });   
  },
});

export const { clearMessage } = inviteSlice.actions;

export default inviteSlice.reducer;
